export const LOCKSMITH_OCCUPATION_ID = 1;
export const GARAGE_OCCUPATION_ID = 3;
export const CARPET_OCCUPATION_ID = 2;

export const SERVICE = {
  HOME: {
    DOOR_LOCKOUT: 18,
    RE_KEY: 19,
    LOCK_CHANGE: 20,
    DOOR_REPAIR: 21,
    FRESH_LOCK: 22,
  },
  COMMERCIAL: {
    LOW_VOLTAGE: 23,
    PANIC_BAR: 24,
    BUZZER: 25,
    EMERGENCY_EXIT: 26,
  },
  AUTO: {
    LOCKOUT: 27,
    NEW_KEY: 28,
    IGNITION: 29,
  },
  SAFE: {
    BASIC_SAFE: 30,
    HIGH_END_SAFE: 31,
  },
  // random service id for yet non existing services
  GARAGE: {
    CABLE_REPAIR: 780,
    SPRING_REPAIR: 781,
    DOOR_INSTALLATION: 782,
    OPENER: 783,
  },
  CARPET: {
    CLEANING: 790,
    DEEP_CLEANING: 791,
    ODOR_REMOVAL: 792,
    STAINS_REMOVAL: 793
  }
};
